'use client'
import { useEffect, useState } from 'react';
import { useTodayLocationVisit, useStartLocationVisit } from '@/hooks/api/useLocationVisits';
import { useNavigate, useParams } from 'react-router-dom';
import { useQueryUsers } from '@/hooks/api/useUsers';
import { useLocationDetails } from '@/hooks/useLocation';
import TitleBar from '../layout/TitleBar';
import GenericForm, { GENERIC_FORM_FIELD_TYPE } from '../form/GenericForm';
import { getFlexNameLabel } from '@/stack-shared/utils/gen-utils';

interface IGoaValue {
    hardIn: number;
    hardOut: number;
    lastHardIn: number;
    lastHardOut: number;
    locationId: number | undefined;
    assetId: string;
    goaId: number | undefined;
}

function LocationServiceStartPage() {
    const navigate = useNavigate();
    const { locationId } = useParams();
    const startLocationVisitMutation = useStartLocationVisit();
    const { data: todayVisitData } = useTodayLocationVisit();
    const queryUsersMutation = useQueryUsers();
    const { data: locationDetails } = useLocationDetails(locationId || '');
    
    const location = locationDetails?.location;
    const [users, setUsers] = useState<any[]>([]);
    
    useEffect(() => {
        queryUsersMutation.mutate({
            skip: 0,
            take: 1000,
            search: '',
            orderBy: 'id',
            orderDirection: 'ASC',
        }, {
            onSuccess: (data: any) => {
                setUsers(data?.data || []);
            },
        });
    }, []);
    
    const todayVisit = todayVisitData && locationId && Number(todayVisitData.locationId) === Number(locationId) ? todayVisitData : null;

    let locationServiceReady = false;
    if (todayVisit) {
        locationServiceReady = true;
    }


    const [breadcrumbs, setBreadcrumb] = useState([
        { label: 'Home', href: '/app/dashboard' },
        { label: 'Service', href: '/app/location-service' },
        { label: location?.name || '' }, // No href for the current page
    ]);

    const startServiceFormGroup = {
        groupName: 'Start site visit',
        fields: [
            { type: GENERIC_FORM_FIELD_TYPE.MULTI_SELECT, label: 'Technicians Present', name: 'users', options: users.map((usr) => { return { label: getFlexNameLabel(usr), value: usr.id?.toString() || "" } }), columns: 12 },
        ]
    }


    if (!locationServiceReady) {
        return (
            <div >
                <TitleBar breadcrumbs={breadcrumbs} title={`Start Site Service`} />
                <p>
                    {new Date().toDateString()}
                </p>
                <GenericForm
                    onSubmit={async (values: any) => {
                        console.log("values", values);
                        // Get today's date in YYYY-MM-DD format (local timezone)
                        const today = new Date();
                        const todayDateStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
                        startLocationVisitMutation.mutate({ 
                            locationId: parseInt(locationId!), 
                            userIds: values.users,
                            date: todayDateStr // Send date in YYYY-MM-DD format to avoid timezone issues
                        }, {
                            onSuccess: (data) => {
                                console.log("data", data);
                                navigate(`/app/location-service/${locationId}`);
                            },
                        })
                    }}
                    groups={[startServiceFormGroup]}
                    title={''}
                    initialValues={{}}
                    formWidth={'xl'}
                    submitLabel='Start Service'
                    // formStyle={{ width: 500, backgroundColor: 'green' }}
                />

            </div>
        )
    }
    else {
        navigate(`/app/location-service/${locationId}`);
    }



    return null;
}

export default LocationServiceStartPage;
